export function downloadBlob(blob, fileName) {
  const downloadable = blob instanceof Blob
    ? blob
    : new Blob([blob], { type: 'application/octet-stream' });
  const url = URL.createObjectURL(downloadable);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  try { link.click(); } finally {
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 60000);
  }
}

export default downloadBlob;
